"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Providers = function (_a) {
    var providers = _a.providers, children = _a.children;
    var providersArray = Array.isArray(providers) ?
        providers :
        React.Children.toArray(providers.props.children);
    var wrapChildrenWithProviderElement = function (children, providerElement) {
        return React.cloneElement(providerElement, undefined, children);
    };
    return React.createElement(React.Fragment, null, providersArray.reduceRight(wrapChildrenWithProviderElement, children));
};
exports.default = Providers;
